import { toast } from 'react-toastify';

import { USER_INFO_FORCED_FIELDS } from 'constants/userInfo';
import { PhoneNumberUtil } from 'google-libphonenumber';

import {
  URL_REGEX,
  EMAIL_REGEX,
  PASSWORD_REGEX,
  ENGLISH_REGEX,
  POSTAL_CODE_REGEX,
  NATIONAL_CODE_REGEX,
  HOME_PHONE_REGEX,
  // HOME_PHONE_EN_REGEX,
  HTTP_REGEX,
  MOBILE_REGEX,
} from './regex';

import { getNotifMsg } from './locale';

export const isValidUrl = (url) => {
  const urlRegex = new RegExp(URL_REGEX);
  return urlRegex.test(url);
};

export const isStartedWithHttp = (url) => {
  const urlRegex = new RegExp(HTTP_REGEX);
  return urlRegex.test(url);
};

export const isValidEmail = (email) => {
  const emailRegex = new RegExp(EMAIL_REGEX);
  return emailRegex.test(email);
};

export const isValidPassword = (password) => {
  const passwordRegex = new RegExp(PASSWORD_REGEX);
  return passwordRegex.test(password);
};

export const isValidName = (name) => {
  if (name.length > 255) {
    return false;
  } else {
    return true;
  }
};

// just iran phone numbers validation
export const isValidIranMobileNum = (mobile) => {
  const mobileRegex = new RegExp(MOBILE_REGEX);
  return mobileRegex.test(mobile);
};

export const isValidMobile = (mobile) => {
  // const mobileRegex = new RegExp(MOBILE_REGEX);
  // const isValidIranianPhoneNumber = mobileRegex.test(mobile);
  // if (isValidIranianPhoneNumber) return true;

  const phoneUtil = PhoneNumberUtil.getInstance();

  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(mobile));
  } catch (error) {
    return false;
  }
};

export const isEnglishChars = (text) => {
  const englishRegex = new RegExp(ENGLISH_REGEX);
  return englishRegex.test(text);
};

export const isValidPostalCode = (postalCode) => {
  const postalCodeRegex = new RegExp(POSTAL_CODE_REGEX);
  return postalCodeRegex.test(postalCode);
};

export const isValidNationalCode = (nationalCode) => {
  const nationalCodeRegex = new RegExp(NATIONAL_CODE_REGEX);
  if (nationalCodeRegex.test(nationalCode)) return false;
  const check = +nationalCode[9];
  const sum =
    nationalCode
      .split('')
      .slice(0, 9)
      .reduce((acc, x, i) => acc + +x * (10 - i), 0) % 11;
  return sum < 2 ? check === sum : check + sum === 11;
};

export const isValidNationalIdentifier = (nationalIdentifier) => {
  const length = nationalIdentifier.length;
  if (length < 11 || parseInt(nationalIdentifier) === 0) return false;
  if (parseInt(nationalIdentifier.substr(3, 6)) === 0) return false;
  var check = parseInt(nationalIdentifier.substr(10, 1));
  var tenthDigit = parseInt(nationalIdentifier.substr(9, 1)) + 2;
  const pattern = [29, 27, 23, 19, 17];
  let sum = 0;
  for (let index = 0; index < 10; index++) {
    sum +=
      (tenthDigit + parseInt(nationalIdentifier.substr(index, 1))) *
      pattern[index % 5];
  }
  let modulus = sum % 11;
  if (modulus === 10) modulus = 0;
  return check === modulus;
};

export const isValidHomePhone = (phone, locale) => {
  // const regex = locale === 'fa' ? HOME_PHONE_REGEX : HOME_PHONE_EN_REGEX;

  const regex = HOME_PHONE_REGEX;

  const homePhoneRegex = new RegExp(regex);
  return homePhoneRegex.test(phone);
};

export const validateCompanyPayment = (values, locale = 'fa') => {
  const { nationalNumber, phone } = values;
  const errors = {};

  if (!nationalNumber) {
    errors.nationalNumber = getNotifMsg('COMPANY_NATIONAL_NUMBER', locale);
  } else if (!isValidNationalIdentifier(nationalNumber)) {
    errors.nationalNumber = getNotifMsg('COMPANY_INVALID_NATIONAL', locale);
  }

  if (phone && !isValidHomePhone(phone, locale)) {
    errors.phone = getNotifMsg('INVALID_PHONE', locale);
  }

  return errors;
};

export const validatePersonPayment = (values, locale) => {
  const { id, residencePostalCode, birthDate } = values;
  const errors = {};

  if (!id) {
    errors.id = getNotifMsg('ENTER_NATIONAL_ID_NUMBER', locale);
  } else if (!isValidNationalCode(id)) {
    errors.id = getNotifMsg('INVALID_NATIONAL_ID_NUMBER', locale);
  }

  if (!residencePostalCode) {
    errors.residencePostalCode = getNotifMsg('ENTER_POSTAL_CODE', locale);
  } else if (
    residencePostalCode.length !== 10 ||
    !isValidPostalCode(residencePostalCode)
  ) {
    errors.residencePostalCode = getNotifMsg('INVALID_POSTAL_CODE', locale);
  }

  if (!birthDate) {
    errors.birthDate = getNotifMsg('ENTER_BIRTH_DATE', locale);
  }
  return errors;
};

export const isImageSizeValidForUpload = (size) => {
  const fileSizeInKiloBtytes = size / 1024;

  return fileSizeInKiloBtytes < 500;
};

export const isValidFileTypeToUploadAsImage = (fileType) => {
  const validFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];

  return validFileTypes.includes(fileType);
};

export const isFileValidToUploadAsImage = (file, locale = 'fa') => {
  // type validation
  if (!isValidFileTypeToUploadAsImage(file.type)) {
    toast.error(getNotifMsg('INVALID_FILE_FORMAT', locale));
    return;
  }

  if (!isImageSizeValidForUpload(file.size)) {
    toast.error(getNotifMsg('IMAGE_SIZE_EXCEED', locale));
    return;
  }

  return true;
};

/**
 * Because of inconsistency in retrieved data from server There are multiple scenarios that should get checked:
 *
 * 1. No data
 * 2. Empty object
 * 3. Some data are partially filled. so neccessary data should get checked
 * 4. mobile number is empty
 *
 * if any of these scenarios are true then the UserInfo modal should appear and get data from user
 */
export const needToCheckUserInfoForcedFields = (data, mobile) => {
  const { selectedForm } = data || {};

  return (
    !selectedForm ||
    USER_INFO_FORCED_FIELDS[selectedForm].some((field) => !data[field]) ||
    !mobile
  );
};
